import api from "./api";

export const stockService = {
  list(params) {
    return api.get("/stock", { params });
  },
  search(params) {
    return api.get("/stock/search", { params });
  },
  downloadTemplate() {
    return api.get("/stock/template", { responseType: "blob" });
  },
  upload(formData, options = {}) {
    const params = {};
    if (options.preview) params.preview = true;

    return api.post("/stock/upload", formData, {
      params,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  get(id) {
    return api.get(`/stock/${id}`);
  },
  create(payload) {
    return api.post("/stock", payload);
  },
  update(id, payload) {
    return api.patch(`/stock/${id}`, payload);
  },
};
